import { useAddNewFirmMutation } from "@/clients/cmaBackend/support";
import { Dialog, DialogContent, DialogTitle } from "@uicomponents/ui/dialog";
import { Button, Paper, TextField } from "@mui/material";
import { useState } from "react";

interface NewFirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  dialogParams: Record<string, never> | null;
}

export function NewFirmDialog({
  isOpen,
  onClose,
  dialogParams,
}: NewFirmDialogProps) {
  const [addNewFirm, { isLoading: isAddingFirm }] = useAddNewFirmMutation();
  const [firmName, setFirmName] = useState("");

  function authDialogOnClose() {
    onClose();
  }

  function handleSave() {
    if (!firmName) return;

    addNewFirm({ displayName: firmName }).then(() => {
      authDialogOnClose();
    });
  }

  return (
    <Dialog
      open={isOpen}
      onClose={authDialogOnClose}
      slotProps={{
        paper: {
          style: {
            maxWidth: "800px",
          },
        },
      }}
    >
      <DialogContent className="sm:max-w-[600px] md:min-w-[800px] p-0 overflow-hidden gap-0">
        <div className="bg-primary p-0 text-primary-foreground flex flex-col items-center justify-center text-center">
          <DialogTitle className="font-heading font-bold mb-1">
            Add a New Firm
          </DialogTitle>
        </div>

        <div className="p-6">
          <TextField
            fullWidth
            label="Firm Name"
            variant="outlined"
            value={firmName}
            onChange={(e) => setFirmName(e.target.value)}
          />

          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "16px" }}
            onClick={handleSave}
            disabled={isAddingFirm || !firmName}
          >
            Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
